import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import GmbAuditPage from '@/pages/gmb-audit/page';
import GmbAuditResultPage from '@/pages/gmb-audit/result/page';
import GmbAuditMethodologyPage from '@/pages/gmb-audit/methodology/page';
import GmbAuditConsultPage from '@/pages/gmb-audit/consult/page';
import GmbAuditPrivacyPage from '@/pages/gmb-audit/privacy/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/gmb-audit" replace />,
  },
  {
    path: '/gmb-audit',
    element: <GmbAuditPage />,
  },
  {
    path: '/gmb-audit/consult',
    element: <GmbAuditConsultPage />,
  },
  {
    path: '/gmb-audit/privacy',
    element: <GmbAuditPrivacyPage />,
  },
  {
    path: '/gmb-audit/result/:auditId',
    element: <GmbAuditResultPage />,
  },
  {
    path: '/gmb-audit/methodology',
    element: <GmbAuditMethodologyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;